module.exports = __webpack_public_path__ + "img/pagnol.c1330856.jpg";